const M = {
        id:          '',
        nameFamily:  '',
        nameFirst:   '',
        nameFathers: '',
        url:         '',
        sex:         '',
        img:         '',
        experience:  '',
        degree:      '',
        rank:        '',
        category:    '',
        price: '',
        specialities_ids: [],
        networkClinics: [],
        info:         '', // walkaround, иначе пустой пробел ставится
        photos: [],
        education:    [
            {
                year:       "",
                univercity: "",
                speciality: "",
                grade:      ""
            }
        ],
        employment:   [
            {
                name:     '',
                position: '',
                m1:       '',
                y1:       '',
                m2:       '',
                y2:       '',
                now:      false
            }
        ],
        certificates: [
            {
                univercity: "",
                year:       [""]
            }
        ],
        associations: [""],

        rating:                 0,
        ratingInternal:         0,
        ratingInternalDetailed: {
            hasBookingButton:     0,
            hasInfo:              0,
            hasImg:               0,
            hasShowInFeedRatings: 0,
            hasUserAccount:       0,
            hasFullFio:           0,
            hasPrice:             0,
            hasEducation:         0,
            hasExperience:        0,
            hasEmployment:        0,
            hasCertificates:      0,
            hasAssociations:      0,
        },

        clinics:      [],
        bestCityCharId: ''
    }



export function GET_DEFAULT_M () { return JSON.parse(JSON.stringify(M));}
export function  initialState() { return JSON.parse(JSON.stringify(
    {
            M: M,
            M_clone: M,
            foundClinics: [],
            duplicateLastSearchedFio: '',
            actionType: '',
            netInvalidShowFlag: false,
            universitiesList: [],
            Mhashcode: null,
            isDuplicate: false,
            clinicSearchRequest: null,
    }
));}
